export default __webpack_public_path__ + "static/media/coloregg1.4cee62ae.png";